import CategoryLinkGalleryUI from '@interflora/ui-components/build/components/CategoryLinkGallery/CategoryLinkGallery'
import { Props as UIProps } from '@interflora/ui-components/build/components/CategoryLinkGallery/CategoryLinkGallery.types'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

const CategoryLinkGallery = (props: UIProps) => {
  const analytics = useAnalytics()

  const sendCategoryCarouselClickAnalytics = (click_text: string) => {
    analytics?.sendCategoryCarouselClickAnalytics(click_text)
  }

  useLoaded(props)

  return <CategoryLinkGalleryUI {...props} sendCategoryCarouselClickAnalytics={sendCategoryCarouselClickAnalytics} />
}

export default CategoryLinkGallery
